import * as React from 'react';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import * as _ from 'lodash';

import { TicketChannelOption } from '@/constants/ticket-channel-option.enum';
import {
  ticketChannelSelector,
  ticketClosedAtSelector,
  ticketCreatedAtSelector,
  ticketDeviceTypeSelector,
  ticketOptionDataSelector,
  ticketTagsSelector,
  ticketUserSelector,
} from '@/redux/app/selectors/ticket';
import { AppNavigatorParamsContext, AccountLink } from '@/lib/navigation';

import { Tag } from '../../../../tag';

export interface PreviousTicketItemProps {
  uuid: string;
}

const MOMENT_FORMAT = 'L [at] h:mm a';

export const PreviousTicketItem = ({ uuid }: PreviousTicketItemProps) => {
  const params = useContext(AppNavigatorParamsContext);
  const channel = useSelector(_.partial(ticketChannelSelector, uuid));
  const createdAt = useSelector(_.partial(ticketCreatedAtSelector, uuid));
  const closedAt = useSelector(_.partial(ticketClosedAtSelector, uuid));
  const user = useSelector(_.partial(ticketUserSelector, uuid));
  const deviceType = useSelector(_.partial(ticketDeviceTypeSelector, uuid));
  const optionData = useSelector(_.partial(ticketOptionDataSelector, uuid));
  const tags = useSelector(_.partial(ticketTagsSelector, uuid));

  return (
    <div id={`prev-convo-${uuid}`}>
      <AccountLink path={`tickets/${uuid}`} params={params}>
        <div className="convo-container convo-link">
          <div className="convo-content">
            <div className="convo-text">Channel:</div>
            <div className="convo-data">
              {TicketChannelOption.human[channel] || 'SMS'}
            </div>
          </div>
          <div className="convo-content">
            <div className="convo-text">Started: </div>
            <div className="convo-data">
              {moment(createdAt * 1000).format(MOMENT_FORMAT)}
            </div>
          </div>
          <div className="convo-content">
            <div className="convo-text">Closed at: </div>
            <div className="convo-data">
              {closedAt ? moment(closedAt * 1000).format(MOMENT_FORMAT) : 'Not Closed'}
            </div>
          </div>
          <div className="convo-content">
            <div className="convo-text">Assigned to:</div>
            <div className="convo-data">
              {user && user.name ? user.name : 'Unassigned'}
            </div>
          </div>
          {deviceType && (
            <div className="convo-content">
              <div className="convo-text">Device:</div>
              <div className="convo-data device-type">
                {deviceType}
              </div>
            </div>
          )}
          {optionData && (
            <div className="convo-content">
              <div className="convo-text">Widget Submission:</div>
              <div className="convo-data">
                {optionData}
              </div>
            </div>
          )}
          {tags && tags.length > 0 && (
            <div className="convo-content">
              <div className="convo-text">Tags: </div>
              <div className="tags-container">
                {tags.map((name) => <Tag key={name} external name={name} search="tickets" />)}
              </div>
            </div>
          )}
        </div>
      </AccountLink>
    </div>
  );
};
